import { derived } from "svelte/store";

import { user } from "$lib/identity/user";

export const DASHBOARD_HREF = "/apps";

/** The sign-up page, returning to `next` once the account exists. */
export function signupHref(next: string = DASHBOARD_HREF): string {
  return `/signup?next=${encodeURIComponent(next)}`;
}

/** The log-in page, returning to `next` once signed in. */
export function loginHref(next: string = DASHBOARD_HREF): string {
  return `/login?next=${encodeURIComponent(next)}`;
}

export const SIGNUP_HREF = signupHref();
export const LOGIN_HREF = loginHref();

/** Sends a logged-in visitor past a signup link, straight to its `next` page. */
export const accountHref = derived(user, ($user) => (href: string) => {
  if (!$user?.loggedIn) return href;
  const url = new URL(href, "https://modal.com");
  if (url.pathname !== "/signup") return href;
  return url.searchParams.get("next") ?? DASHBOARD_HREF;
});
